import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
type LegalModalProps = {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
};
export function LegalModal({
  isOpen,
  onClose,
  title,
  children
}: LegalModalProps) {
  return <AnimatePresence data-id="element-72">
      {isOpen && <>
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50" onClick={onClose} data-id="element-73" />
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        duration: 0.25
      }} className="fixed inset-4 md:inset-auto md:top-1/2 md:left-1/2 md:-translate-x-1/2 md:-translate-y-1/2 md:w-full md:max-w-2xl md:max-h-[80vh] bg-white rounded-2xl shadow-2xl z-50 flex flex-col overflow-hidden" data-id="element-74">
            <div className="flex items-center justify-between p-6 border-b border-slate-200" data-id="element-75">
              <h2 className="font-heading text-xl font-bold text-slate-900" data-id="element-76">
                {title}
              </h2>
              <button onClick={onClose} className="p-2 rounded-lg hover:bg-slate-100 transition-colors text-slate-500 hover:text-slate-800" data-id="element-77">
                <XIcon className="w-5 h-5" data-id="element-78" />
              </button>
            </div>
            <div className="p-6 overflow-y-auto text-slate-700 text-sm leading-relaxed space-y-4" data-id="element-79">
              {children}
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
}